// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fa226d {
  margin: 0 0 8px;
}
.ce349c {
  line-height: 1.285714286;
  font-size: 1.75rem;
  font-family: "HM Sans Semi Bold", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 500;
  text-transform: none;
}
.e916c9 {
  line-height: 1.166666667;
  font-size: 1.5rem;
  font-family: "HM Sans Semi Bold", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 500;
  text-transform: none;
}
.af6753 {
  line-height: 1.2;
  font-size: 1.25rem;
  font-family: "HM Sans Semi Bold", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 500;
  text-transform: none;
}
.ca21a4 {
  line-height: 1.25;
  font-size: 1rem;
  font-family: "HM Sans Semi Bold", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 500;
  text-transform: none;
}
.c0e4fd {
  line-height: 1.25;
  font-size: 0.8125rem;
  font-family: "HM Sans Semi Bold", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 500;
  text-transform: none;
}
.f4232a.f4232a {
  margin: 0;
}
.eab22d {
  text-align: center;
}
.cf0cea {
  text-align: left;
}
.eab090 {
  text-align: right;
}
.b8f120 {
  width: 100%;
}
.d89bf0 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.f0b963 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.b8da82 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.c3b93b {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.b5b9db {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

@supports (-webkit-line-clamp: 2) {
  .f0b963 {
    white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
  }
}

@supports (-webkit-line-clamp: 3) {
  .b8da82 {
    white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
  }
}

@supports (-webkit-line-clamp: 4) {
  .c3b93b {
    white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
  }
}

@supports (-webkit-line-clamp: 5) {
  .b5b9db {
    white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
  }
}

@media screen and (min-width: 768px) {
  .ce349c {
    line-height: 1.2;
      font-size: 2.5rem;
  }
  .e916c9 {
    line-height: 1.142857143;
      font-size: 1.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/Typography/headings/Heading/Heading.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,0IAA0I;EAC1I,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,0IAA0I;EAC1I,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0IAA0I;EAC1I,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,0IAA0I;EAC1I,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,0IAA0I;EAC1I,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;MAClB,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;EAChC;AACF;;AAEA;EACE;IACE,oBAAoB;MAClB,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;EAChC;AACF;;AAEA;EACE;IACE,oBAAoB;MAClB,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;EAChC;AACF;;AAEA;EACE;IACE,oBAAoB;MAClB,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;EAChC;AACF;;AAEA;EACE;IACE,gBAAgB;MACd,iBAAiB;EACrB;EACA;IACE,wBAAwB;MACtB,kBAAkB;EACtB;AACF","sourcesContent":[".fa226d {\n  margin: 0 0 8px;\n}\n.ce349c {\n  line-height: 1.285714286;\n  font-size: 1.75rem;\n  font-family: \"HM Sans Semi Bold\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 500;\n  text-transform: none;\n}\n.e916c9 {\n  line-height: 1.166666667;\n  font-size: 1.5rem;\n  font-family: \"HM Sans Semi Bold\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 500;\n  text-transform: none;\n}\n.af6753 {\n  line-height: 1.2;\n  font-size: 1.25rem;\n  font-family: \"HM Sans Semi Bold\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 500;\n  text-transform: none;\n}\n.ca21a4 {\n  line-height: 1.25;\n  font-size: 1rem;\n  font-family: \"HM Sans Semi Bold\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 500;\n  text-transform: none;\n}\n.c0e4fd {\n  line-height: 1.25;\n  font-size: 0.8125rem;\n  font-family: \"HM Sans Semi Bold\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 500;\n  text-transform: none;\n}\n.f4232a.f4232a {\n  margin: 0;\n}\n.eab22d {\n  text-align: center;\n}\n.cf0cea {\n  text-align: left;\n}\n.eab090 {\n  text-align: right;\n}\n.b8f120 {\n  width: 100%;\n}\n.d89bf0 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.f0b963 {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.b8da82 {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.c3b93b {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.b5b9db {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n@supports (-webkit-line-clamp: 2) {\n  .f0b963 {\n    white-space: initial;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n  }\n}\n\n@supports (-webkit-line-clamp: 3) {\n  .b8da82 {\n    white-space: initial;\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n  }\n}\n\n@supports (-webkit-line-clamp: 4) {\n  .c3b93b {\n    white-space: initial;\n      display: -webkit-box;\n      -webkit-line-clamp: 4;\n      -webkit-box-orient: vertical;\n  }\n}\n\n@supports (-webkit-line-clamp: 5) {\n  .b5b9db {\n    white-space: initial;\n      display: -webkit-box;\n      -webkit-line-clamp: 5;\n      -webkit-box-orient: vertical;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .ce349c {\n    line-height: 1.2;\n      font-size: 2.5rem;\n  }\n  .e916c9 {\n    line-height: 1.142857143;\n      font-size: 1.75rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
